import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

export const deleteA2AIpAllowlist = async (): Promise<void> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('No organization selected');
  }

  const response = await apiRequest({
    url: `/organizations/${orgId}/a2a-ip-allowlist`,
    method: 'DELETE',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(response.detail || 'Failed to delete A2A IP allowlist');
  }
};
